// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"styles_tableBody__2A_Ei"};